import React from "react";
import { Link } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";

const useStyles = makeStyles(() => ({
  root: {
    background: "#fff",
    borderTop: "1px solid lightgray",
    padding: "1rem",
    minHeight: 300,
    left: 0,
    bottom: 0,
    position: "relative",
    width: "100%",
  },
  subdetail: {
    marginLeft: "1rem",
    textDecoration: "none",
    color: "#05ce91",
  },
  twitterLogo: {
    border: "1px solid #1DA1F2",
    marginLeft: "1rem",
    color: "#1DA1F2",
  },
  facebookLogo: {
    border: "1px solid #4267B2",
    marginLeft: 5,
    color: "#4267B2",
  },
  instagramLogo: {
    border: "1px solid #8a3ab9",
    marginLeft: 5,
    color: "#8a3ab9",
  },
  bar: {
    height: 2,
    background: "#005bff",
    marginLeft: "1rem",
  },
}));

export default function Footer({}) {
  const classes = useStyles();
  return (
    <Grid className={classes.root} container direction="column" spacing={2}>
      <Grid item xs={10}>
        <Typography variant="h6" color="secondary">
          CryptoPredictor
        </Typography>
        <Typography variant="subtitle1" className={classes.subdetail}>
          Stay updated about the crypto world through our website. Get daily
          forecast of different crypto-currencies
        </Typography>
      </Grid>
      <Grid item container direction="column">
        <Typography variant="h6" color="secondary">
          Explore site
        </Typography>
        <Typography
          variant="subtitle1"
          className={classes.subdetail}
          component={Link}
          to="/currencies"
        >
          See all currencies
        </Typography>
        <div className={classes.bar} style={{ width: 100 }}></div>
        <Typography
          variant="subtitle1"
          className={classes.subdetail}
          component={Link}
          to="/news"
        >
          See News
        </Typography>
        <div className={classes.bar} style={{ width: 50 }}></div>
        <Typography
          variant="subtitle1"
          className={classes.subdetail}
          component={Link}
          to="/about"
        >
          About us
        </Typography>
        <div className={classes.bar} style={{ width: 50 }}></div>
      </Grid>
      <Grid item container alignItems="center">
        <Typography variant="subtitle2" color="primary">
          Connect with us
        </Typography>
        <IconButton className={classes.twitterLogo}>
          <TwitterIcon fontSize="small" />
        </IconButton>
        <IconButton className={classes.facebookLogo}>
          <FacebookIcon fontSize="small" />
        </IconButton>
        <IconButton className={classes.instagramLogo}>
          <InstagramIcon fontSize="small" />
        </IconButton>
      </Grid>
      <Grid item align="center" style={{ borderTop: "1px solid lightgray" }}>
        <Typography
          variant="body2"
          color="primary"
          style={{ cursor: "pointer" }}
        >
          copyright informations
        </Typography>
      </Grid>
    </Grid>
  );
}
